import {
    MdInbox,
    MdStar,
    MdSend,
    MdDrafts,
    MdDelete,
    MdAllInbox,
    MdEdit,
} from 'react-icons/md'
import type { EmailAccount, EmailFolder } from '@/lib/api/administrative/inbox-api'

interface FolderSidebarProps {
    selectedFolder: EmailFolder
    onFolderChange: (folder: EmailFolder) => void
    accounts: EmailAccount[]
    selectedAccountId: number | null
    onAccountChange: (id: number | null) => void
    onCompose: () => void
    canCreate?: boolean
}

const FOLDERS: { id: EmailFolder; label: string; icon: typeof MdInbox }[] = [
    { id: 'INBOX', label: 'Caixa de Entrada', icon: MdInbox },
    { id: 'STARRED', label: 'Com Estrela', icon: MdStar },
    { id: 'SENT', label: 'Enviados', icon: MdSend },
    { id: 'DRAFT', label: 'Rascunhos', icon: MdDrafts },
    { id: 'TRASH', label: 'Lixeira', icon: MdDelete },
    { id: 'ALL', label: 'Todos', icon: MdAllInbox },
]

export default function FolderSidebar({
    selectedFolder,
    onFolderChange,
    accounts,
    selectedAccountId,
    onAccountChange,
    onCompose,
    canCreate,
}: FolderSidebarProps) {
    return (
        <div className="flex flex-col gap-2 w-full">
            {canCreate && (
                <button
                    onClick={onCompose}
                    className="btn btn-secondary btn-sm gap-2 w-full"
                >
                    <MdEdit className="text-lg" />
                    Novo Email
                </button>
            )}

            <div className="divider my-0" />

            <ul className="menu menu-sm p-0 gap-0.5">
                {FOLDERS.map(folder => {
                    const Icon = folder.icon
                    const isActive = selectedFolder === folder.id
                    return (
                        <li key={folder.id}>
                            <button
                                onClick={() => onFolderChange(folder.id)}
                                className={`${isActive ? 'active' : ''} flex items-center gap-2`}
                            >
                                <Icon className="text-base" />
                                <span className="text-sm">{folder.label}</span>
                            </button>
                        </li>
                    )
                })}
            </ul>

            {accounts.length > 0 && (
                <>
                    <div className="divider my-0" />
                    <p className="text-xs font-semibold text-base-content/50 px-2 mb-1">
                        Contas
                    </p>
                    <ul className="menu menu-sm p-0 gap-0.5">
                        <li>
                            <button
                                onClick={() => onAccountChange(null)}
                                className={`text-sm ${!selectedAccountId ? 'active' : ''}`}
                            >
                                Todas as contas
                            </button>
                        </li>
                        {accounts.map(account => (
                            <li key={account.id}>
                                <button
                                    onClick={() =>
                                        onAccountChange(account.id)
                                    }
                                    className={`flex items-center gap-2 text-sm ${selectedAccountId === account.id ? 'active' : ''}`}
                                >
                                    {account.picture ? (
                                        <img
                                            src={account.picture}
                                            alt=""
                                            className="w-5 h-5 rounded-full"
                                        />
                                    ) : (
                                        <div className="w-5 h-5 rounded-full bg-secondary/20 flex items-center justify-center text-xs font-bold">
                                            {(
                                                account.name ||
                                                account.email
                                            )[0].toUpperCase()}
                                        </div>
                                    )}
                                    <span className="truncate text-xs">
                                        {account.email}
                                    </span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    )
}
